<template>
	<div>

		<div>
			<div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">审批流管理</div>
			<el-row style="margin-top: 9px;">
				<div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px;">

					<el-row style="padding-left: 46px; padding-top: 40px;">

						<el-col :span="5">
							<span>审批流名称</span>
							<el-input v-model="condition.name" placeholder="请输入审批流名称"
								style="width: 65%; margin-left: 10px;">
							</el-input>
						</el-col>

						<el-col :span="4">
							<span>类型</span>
							<el-select v-model="condition.type" placeholder="全部" clearable
								style="width: 70%; margin-left: 10px;" filterable>
								<el-option v-for="item in typeList" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-col>

						<el-col :span="4">
							<span>状态</span>
							<el-select v-model="condition.state" placeholder="全部" clearable
								style="width: 70%; margin-left: 10px;" filterable>
								<el-option label="启用" value="1"></el-option>
								<el-option label="停用" value="0"></el-option>
							</el-select>
						</el-col>

						<el-col :span="5">
							<el-button
								style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
								@click="Find">
								查询</el-button>
							<el-button
								style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
								@click="Del(null)">
								删除</el-button>
							<el-button style="width: 85px; border: 1px solid #006E4B; color: #006E4B;" @click="AddFrom">
								新增</el-button>
						</el-col>

					</el-row>

					<el-row style="margin: 0px 2%; margin-top: 10px;">
						<el-row>
							<el-table :header-cell-style="{ background: '#F0F0F0', color: '#000000' }"
								ref="multipleTable" :data="tableData" height="540" tooltip-effect="dark"
								style="width: 100%;" @selection-change="handleSelectionChange">
								<el-table-column type="selection" width="55">
								</el-table-column>
								<el-table-column align="center" label="序号">
									<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
								</el-table-column>
								<el-table-column prop="name" align="center" label="审批流名称"></el-table-column>
								<el-table-column prop="type_title" align="center" label="类型"></el-table-column>
								<el-table-column prop="state_title" align="center" label="状态"></el-table-column>
								<el-table-column align="center" label="操作">
									<template slot-scope="scope">
										<img src="../../../assets/调整部门.png" @click="Start(scope.row)" />
										<img src="../../../assets/编辑.png" @click="UpdateFrom(scope.row)" />
										<img src="../../../assets/删除.png" @click="Del(scope.row.id)" />
									</template>
								</el-table-column>
							</el-table>
						</el-row>
						<el-row style="margin-top: 10px; text-align: center;">
							<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
								layout=" prev, pager, next, jumper" :total="total">
							</el-pagination>
						</el-row>
					</el-row>
				</div>
			</el-row>
		</div>

		<div class="dialog">
			<el-dialog :title="from.id == null || from.id == '' ? '添加审批流' : '修改审批流'" :visible.sync="dialogVisible"
				width="56%" :close-on-click-modal="false" ::center="true" :destroy-on-close="true">
				<add ref="add" class="dialogdiv" :data="from"></add>
			</el-dialog>
		</div>

	</div>
</template>

<script>
	import add from './Flow_add.vue';

	import axios from "axios";
	export default {
		components: {
			add: add,
		},
		data() {
			return {
				//列表相关
				page_num: 1,
				page_size: 10,
				total: 0,
				tableData: [],

				//页面相关
				dialogVisible: false,

				//类型下拉
				typeList: [{
						value: 1,
						label: "加班审批"
					},
					{
						value: 2,
						label: "请假审批"
					},
					{
						value: 3,
						label: "岗位支援审批"
					},
					{
						value: 4,
						label: "离职审批"
					},
					{
						value: 5,
						label: "代岗审批"
					},
					{
						value: 6,
						label: "外出审批"
					},
					{
						value: 7,
						label: "调薪审批"
					},
					{
						value: 8,
						label: "补卡审批"
					},
					{
						value: 9,
						label: "出差审批"
					},
					{
						value: 10,
						label: "处罚审批"
					},
					{
						value: 11,
						label: "入职审批"
					},
					{
						value: 12,
						label: "调岗审批"
					},
					{
						value: 13,
						label: "转正审批"
					},
					{
						value: 14,
						label: "工资明细审批"
					},
					{
						value: 15,
						label: "工资占比审批"
					},
					{
						value: 16,
						label: "工资汇总审批审批"
					}
				],

				//条件
				condition: {
					name: "",
					type: "",
					state: "",
				},

				//详情
				from: {
					id: "",
					name: "",
					type: "",
					state: "",
					sysFlowDetails: [{
						flow_id: "",
						node: 0,
						role_id: "",
						is_leadership: 1,
						ids: []
					}],

					sysFlowCriterias: [{
						node: 0,
						approval_condition_type: "1",
						approval_criteria: "3",
						judgment_conditions: "",
						ids: []
					}],
				},

				//复选框ids
				ids: [],
			};
		},
		methods: {
			//启用操作
			Start(e) {
				this.$confirm('请确认此操作!', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					const url = this.$globals.http + "flow/start";
					axios.post(url, {
						type: e.type,
						id: e.id
					}).then((response) => {
						var code = response.data.code;
						var data = response.data.data;
						if (code === '200') {
							this.$message.success(data);
							this.Find();
						} else {
							this.$message.warning(data);
						}
					}).catch((error) => {
						console.log(error)
						this.$message.error("服务器未响应！请稍后重试");
					})
				}).catch(() => {
					this.$message.info("已取消启用");
				});
			},
			//返回
			Return() {
				this.dialogVisible = false;
				this.trash();
				this.Find();
			},
			//列表点击复选框
			handleSelectionChange(e) {
				this.ids = [];
				e.forEach(item => {
					this.ids.push(item.id);
				})
			},
			//查询
			Find() {
				const url = this.$globals.http + "flow/find";
				axios.post(url, {
					page_num: this.page_num,
					page_size: this.page_size,
					name: this.condition.name,
					type: this.condition.type,
					state: this.condition.state,
				}).then((response) => {
					var code = response.data.code;
					var data = response.data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
					} else {
						this.$message.warning("请求失败！请稍后重试");
					}
				}).catch((error) => {
					console.log(error)
					this.$message.error("服务器未响应！请稍后重试");
				})
			},
			//分页查询
			handleCurrentChange(e) {
				this.page_num = e;
				this.Find();
			},
			//新增页面
			AddFrom() {
				this.trash();
				this.dialogVisible = true;
				// this.$refs["add"].from = this.from;
				// this.$refs["add"].objestSize = [];
				// this.$refs["add"].objestSize2 = [];
				// this.from.sysFlowDetails.forEach(item => {
				// 	this.$refs["add"].objestSize.push(1);
				// });
				// this.from.sysFlowCriterias.forEach(item => {
				// 	this.$refs["add"].objestSize2.push(1);
				// })
			},
			//编辑页面
			UpdateFrom(e) {
				// this.Find();
				this.trash();
				this.from.id = e.id;
				this.from.name = e.name;
				this.from.type = e.type;
				this.from.state = e.state;
				this.from.sysFlowDetails = e.sysFlowDetails;
				this.from.sysFlowCriterias = e.sysFlowCriterias;
				// this.from = {
				// 	id: e.id,
				// 	name: e.name,
				// 	type: e.type,
				// 	state: e.state,
				// 	sysFlowDetails: e.sysFlowDetails,
				// 	sysFlowCriterias: e.sysFlowCriterias,
				// };
				this.dialogVisible = true;

				this.$nextTick(() => {
					this.$refs["add"].from.id = e.id;
					this.$refs["add"].from.name = e.name;
					this.$refs["add"].from.type = e.type;
					this.$refs["add"].from.state = e.state;

					this.$refs["add"].objestSize = [];
					this.$refs["add"].from.sysFlowDetails = [];
					this.from.sysFlowDetails.forEach(item => {
						this.$refs["add"].from.sysFlowDetails.push(item);
						this.$refs["add"].objestSize.push(1)
					})
					
					this.$refs["add"].objestSize2 = [];
					this.$refs["add"].from.sysFlowCriterias = [];
					this.from.sysFlowCriterias.forEach(item => {
						this.$refs["add"].from.sysFlowCriterias.push(item);
						this.$refs["add"].objestSize2.push(1)
					})

				})
				

				// this.$refs["add"].objestSize = [];
				// this.$refs["add"].objestSize2 = [];
				// this.from.sysFlowDetails.forEach(item => {
				//     // item.is_leadership = item.is_leadership == 1 ? true : false;
				//     this.$refs["add"].objestSize.push(1);
				// })

				// this.from.sysFlowCriterias.forEach(item => {
				//     // item.is_leadership = item.is_leadership == 1 ? true : false;
				//     this.$refs["add"].objestSize2.push(1);
				// })
				// this.$refs["add"].from = this.from;
			},
			//删除
			Del(e) {
				var ids;
				if (e === null || e === "" || e === undefined) {
					if (this.ids === null || this.ids.length <= 0) {
						this.$message.warning("请先选择操作数据！");
						return false;
					}
					ids = this.ids;
				} else {
					ids = [e];
				}

				const url = this.$globals.http + "flow/del";
				axios.post(url, {
					ids: ids,
				}).then((response) => {
					var code = response.data.code;
					var data = response.data.data;

					if (code === '200') {

						this.$message.success(data);
						this.Find();

					} else {
						this.$message.warning(data);
					}
				}).catch((error) => {
					console.log(error)
					this.$message.error("服务器未响应！请稍后重试");
				})
			},
			//清除数据
			trash() {
				this.from = {
					id: "",
					name: "",
					type: "",
					state: "",
					sysFlowDetails: [{
						flow_id: "",
						node: 0,
						role_id: "",
						is_leadership: 1,
						ids: []
					}],

					sysFlowCriterias: [{
						node: 0,
						approval_condition_type: "1",
						approval_criteria: "3",
						judgment_conditions: "",
						ids: []
					}],
				};
			}
		},
		created() {
			this.Find();
		}
	}
</script>

<style scoped="scoped">
	>>>.el-button:hover {
		background-color: #FFFFFF;
	}

	>>>.el-button:focus {
		background-color: #FFFFFF;
	}

	>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #006E4B;
	}

	>>>.el-input__inner:focus {
		border-color: #006E4B;
	}

	>>>.el-select .el-input.is-focus .el-input__inner {
		border-color: #006E4B;
	}

	>>>.el-checkbox__input.is-checked .el-checkbox__inner,
	>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #006E4B;
		border-color: #006E4B;
	}

	>>>.el-checkbox__inner:hover {
		border-color: #006E4B;
	}
</style>



// WEBPACK FOOTER //
// Flow.vue?1ba87d02